import styled from "styled-components";
import { Container } from "components/shared";

export const SkillsContainer = styled(Container)`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(10rem, 1fr));
    margin-top: 3rem;
    gap: 2.5rem;
    svg {
    }
`;

export const Icon = styled.svg`
    display: block;
    width: 100%;
    height: 7rem;
    &:hover {
        transform: scale(1.1);
        filter: drop-shadow(0 0 0.3rem var(--${({ color }) => color}));
    }
`;
